import React from 'react'
import { UserAdd } from 'iconsax-react'
import { useTheme } from '@mui/material'

import UserSearchDropdown from '../UserSearchDropdown'
import Tooltip from '../../atoms/Tooltip'

import useStyles from './styles'

type EditSingleUserProps = {
  value: string
  onChange: (id: string) => void
  type: string
  external?: boolean
}

const EditSingleUser: React.FC<EditSingleUserProps> = ({
  value,
  onChange,
  type,
  external
}) => {
  const theme = useTheme()

  const classes = useStyles()

  const handleSelect = React.useCallback(
    (newID: string) => {
      onChange(newID)
    },
    [onChange]
  )

  return (
    <UserSearchDropdown
      selected={value}
      onSelect={handleSelect}
      limit={10}
      external={external}
      prevSelected={[]}
      anchorClass={classes.anchor}
    >
      <div className={classes.select}>
        <Tooltip title={`Set ${type}`} arrow>
          <div className={classes.root}>
            <UserAdd size={theme.size.base} color='#aaa' />
          </div>
        </Tooltip>
      </div>
    </UserSearchDropdown>
  )
}

export default EditSingleUser
